import { httpClient } from "@/services";
export default {
	state: {
		calendarEventsList: null,
	},
	mutations: {
		updateCalendarEventsList(state, payload) {
			state.calendarEventsList = payload.result;
		},
		updateVacationSet(state, payload) {
			console.log('%c [  payload  ] ', 'color:#bada55', typeof payload, payload );
		},
	},
	actions: {

		async getCalendarEventsList({ dispatch, commit }, values) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.post('/info/vacation/list', values);
				if (data && data.status) {
					commit('updateCalendarEventsList', data);
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async setCalendarEventsList({ dispatch, commit }, values) {
			try {
				dispatch('actionPreloader', true);

				const { data } = await httpClient.post('/info/vacation/request', values);
				if (data && data.status) {
					commit('updateVacationSet', data);
					dispatch('setAlert', { type: "success", message: "Vacation request sent. 👌👋👍" });
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},

	},
	getters: {
		calendarEventsList: s => s.calendarEventsList,
	}
};
